var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7a15ddcd150a41ecba92db7e9ea52daf26695f5b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["form-template-v1@claimscore-2f"]={id:"7a15ddcd150a41ecba92db7e9ea52daf26695f5b"};
      